/**************************************************
 * Nombre:       Producto_Imangenes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import foto from '../../../../Recursos/tmp_producto.png'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Producto_Imangenes = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: !masSM ? 1 : 4}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={foto} width="100%" height="auto"/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={2}
            >

                {items.map(producto => {
                    return (
                        <Grid container size={{xs: 3, sm: 3, md: 3}}
                              sx={{
                                  justifyContent: 'center',
                                  border: 1,
                                  borderRadius: !masSM ? 2 : 4,
                                  borderColor: '#00000030'
                              }}>
                            <img src={foto} width="90%" height="auto" style={{borderRadius: !masSM ? 6 : 10}}/>
                        </Grid>
                    )
                })}

            </Grid>

        </Grid>
    )

}
export default Producto_Imangenes

const items = [foto, foto, foto, foto]